import { Api } from "laravel-request";

export const getManagers = (callback: (data: unknown) => void) => {
    Api.get("employee", "index").all(({ data }) => {
        callback(data);
    });
};

export const getPermissions = (callback: (data: unknown) => void) => {
    Api.get("permission", "index").all(({ data }) => callback(data));
};

export const getUserPermissions = (callback: (data: unknown) => void) => {
    Api.get("permission-user", "index").all(({ data }) => callback(data));
};
